import { firestoreAction } from 'vuexfire'
import * as firebase from 'firebase'
import db from '@/db'
import _ from 'lodash'

const tasksRef = db.collection('tasks')
const estimatesRef = db.collection('estimates')
const orgRef = db.collection('organization')
const updated = firebase.default.firestore.FieldValue.serverTimestamp()

const initialState = {
  tasks: [],
  tasksLoading: true
}

const state = Object.assign({}, initialState)

const mutations = {
  'SET_TASKS_LOADING' (state, loading) {
    state.tasksLoading = loading
  },
  'RESET_STATE' (state) {
    for (let prop in state) {
      state[prop] = initialState[prop]
    }
  }
}

const actions = {
  resetTaskState: firestoreAction(({ commit, unbindFirestoreRef }) => {
    unbindFirestoreRef('tasks')
    commit('RESET_STATE')
  }),
  setTasksRef: firestoreAction(({ bindFirestoreRef, commit, dispatch }, ref) => {
    bindFirestoreRef('tasks', ref).then(response => {
      commit('SET_TASKS_LOADING', false)
      dispatch('toggleLoading', false)
    }).catch(error => {
      console.log(error)
    })
  }),
  addTask: ({ commit, dispatch }, payload) => {
    const taskData = {
      organization: payload.organization,
      owner: payload.owner,
      estimate: payload.estimate,
      name: '',
      lowEstimate: '',
      highEstimate: '',
      role: 'zzzzz',
      person: 'zzzzz',
      updated: updated,
      created: updated,
      order: payload.order
    }
    tasksRef.add(taskData).then(task => {
      // Set task reference
      const taskKey = 'tasks.' + task.id
      const taskInfo = {
        updated: updated
      }
      taskInfo[taskKey] = true

      // Add to associated org and estimate
      const batch = db.batch()
      const org = orgRef.doc(payload.organization)
      batch.update(org, taskInfo)
      const estimate = estimatesRef.doc(payload.estimate)
      batch.update(estimate, taskInfo)
      batch.commit().then(response => {
        dispatch('calculateBudget', payload.estimate)
      }).catch(error => {
        console.log(error)
      })
    }).catch(error => {
      console.log(error)
    })
  },
  editTask: ({ commit, dispatch }, payload) => {
    const task = { ...payload }
    task.updated = updated
    Object.keys(task).forEach(key => task[task.id] === undefined && delete task[task.id])
    tasksRef.doc(task.id).update(task).then(response => {
      dispatch('calculateBudget', task.estimate)
    }).catch(error => {
      console.log(error)
    })
  },
  removeTask: ({ commit, dispatch }, payload) => {
    const batch = db.batch()

    // Delete task
    const task = tasksRef.doc(payload.id)
    batch.delete(task)

    // Find references
    const estimate = estimatesRef.doc(payload.estimate)
    const org = orgRef.doc(payload.organization)

    // Set task info
    const taskField = 'tasks.' + payload.id
    const taskInfo = {}
    taskInfo.updated = updated
    taskInfo[taskField] = firebase.default.firestore.FieldValue.delete()
    // Updates
    batch.update(estimate, taskInfo)
    batch.update(estimate, { updated: updated })
    batch.update(org, taskInfo)
    batch.commit().then(response => {
      dispatch('calculateBudget', payload.estimate)
    }).catch(error => {
      console.log(error)
    })
  },
  orderTasks: ({ dispatch }, payload) => {
    let i = 0
    const batch = db.batch()
    payload.forEach(item => {
      const doc = tasksRef.doc(item.id)
      batch.update(doc, { order: i })
      i++
    })
    batch.commit().then(response => {
      dispatch('saveState', true)
    }).catch(error => {
      console.log(error)
    })
  },
  duplicateTasks: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      let i = 0
      const tasks = {}
      Object.keys(payload.tasks).forEach(task => {
        const storedTask = getters.task(task)
        const taskData = { ...storedTask }
        taskData.updated = updated
        taskData.created = updated
        taskData.estimate = payload.newEstimate
        taskData.owner = payload.owner
        let id = null
        tasksRef.add(taskData).then(entry => {
          id = entry.id
          let taskInfo = {
            updated: updated
          }
          const taskKey = 'tasks.' + id
          taskInfo[taskKey] = true
          tasks[id] = true
          estimatesRef.doc(payload.newEstimate).update(taskInfo).then(response => {
            orgRef.doc(payload.organization).update(taskInfo).then(response => {
              i++
              if (i === Object.keys(payload.tasks).length) {
                resolve('Done')
              }
            }).catch(error => {
              console.log(error)
            })
          }).catch(error => {
            console.log(error)
          })
        }).catch(error => {
          console.log(error)
        })
      })
    })
  },
  duplicateAllTasks: ({ dispatch, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      const oldTasks = { ...state.tasks }
      const taskMatrix = {}
      const batch = db.batch()
      let taskCount = 0
      Object.keys(oldTasks).forEach(task => {
        const newTask = { ...oldTasks[task] }
        const oldTask = oldTasks[task].id
        delete newTask.id
        const estimate = payload.estimates[newTask.estimate]
        newTask.estimate = estimate
        newTask.owner = payload.user
        newTask.created = updated
        newTask.updated = updated
        newTask.organization = payload.org
        if (payload.person[newTask.person]) {
          newTask.person = payload.person[newTask.person]
        } else {
          newTask.person = false
        }
        if (payload.role[newTask.role]) {
          newTask.role = payload.role[newTask.role]
        } else {
          newTask.role = false
        }
        tasksRef.add(newTask).then(reference => {
          taskMatrix[oldTask] = reference.id
          const org = orgRef.doc(payload.org)
          const est = estimatesRef.doc(estimate)
          const orgKey = 'tasks.' + reference.id
          const orgInfo = {}
          orgInfo[orgKey] = true
          batch.update(est, orgInfo)
          batch.update(org, orgInfo)
          taskCount++
          if (taskCount === state.tasks.length) {
            commitBatch()
          }
        })
        function commitBatch () {
          batch.commit().then(response => {
            resolve(taskMatrix)
          }, error => {
            reject(error)
          })
        }
      })
    })
  }
}

const getters = {
  tasksLoading: state => {
    return state.tasksLoading
  },
  allTasks: (state, rootGetters) => {
    return state.tasks
  },
  task: state => (key) => {
    return state.tasks.find(task => task.id === key)
  },
  tasks: state => (id) => {
    const tasks = state.tasks.filter(tasks => tasks.estimate === id)
    return _.orderBy(tasks, 'order')
  },
  taskRole: state => (id, role) => {
    return state.tasks.filter(tasks => tasks.estimate === id && tasks.role === role)
  },
  taskPerson: state => (id, person) => {
    return state.tasks.filter(tasks => tasks.estimate === id && tasks.person === person)
  },
  roleTasks: state => (role) => {
    return state.tasks.filter(tasks => tasks.role === role)
  },
  teamTasks: state => (person) => {
    return state.tasks.filter(tasks => tasks.person === person)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
